import React from 'react';
import { useSelector } from 'react-redux';
import { updateFormatOption } from '../../../redux/ChartPoperties/ChartControlsActions';
import { ChartConXAxisFormats } from '../../../redux/ChartPoperties/ChartControlsInterface';
import InputPositiveNumber from '../CommonFunctions/InputPositiveNumber';
import { Checkbox, TextField, Tooltip } from '@mui/material';
import { RootState } from '../../../redux';
import { useDispatch } from 'react-redux';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const XAxisFormat = ({
  seriesNumber = '1',
  iconColor,
  backgroundColor,
}: {
  seriesNumber?: string;
  iconColor?: string;
  backgroundColor?: string;
}) => {
  const { chartControls, propKey } = useSelector((state: RootState) => {
    const tabTileProps = state.tabTileProps;

    const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

    const chartControls = state.chartControls;

    return { chartControls, propKey };
  });

  const dispatch = useDispatch();

  let formatObject: ChartConXAxisFormats =
    chartControls.properties[propKey].formatOptions.xAxisFormats;

  const separatorOptions: any[] = [
    { type: 'None', value: 'None' },
    { type: 'Comma', value: 'Comma' },
    { type: 'Abbrev', value: 'Abbrev' },
  ];

  const renderSeparatorOptions = () => {
    return separatorOptions.map((item) => {
      const isSelected = item.value === formatObject[seriesNumber].numberSeparator;
      return (
        <div
          key={item.value}
          className={
            item.value === formatObject[seriesNumber].numberSeparator
              ? 'radioButtonSelected'
              : 'radioButton'
          }
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
          }}
          onClick={() => {
            dispatch(
              updateFormatOption(
                propKey,
                'xAxisFormats',
                'numberSeparator',
                item.value,
                seriesNumber,
              ),
            );
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  const formatOptions: any[] = [
    { type: 'Number', value: 'Number' },
    { type: 'Currency', value: 'Currency' },
    { type: 'Percent', value: 'Percent' },
  ];

  const renderFormatOptions = () => {
    return formatOptions.map((item: any) => {
      const isSelected = item.value === formatObject[seriesNumber].formatValue;

      return (
        <div
          key={item.value}
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
          }}
          onClick={() => {
            dispatch(
              updateFormatOption(propKey, 'xAxisFormats', 'formatValue', item.value, seriesNumber),
            );
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        FORMAT
      </div>
      {/*  */}
      <div style={{ marginBottom: '10px' }}>
        <div
          className="optionDescription"
          style={{ marginTop: '0px', color: iconColor ? iconColor : '#404040' }}
        >
          Format Value
        </div>
        <div className="radioButtons" style={{ padding: '0' }}>
          {renderFormatOptions()}
        </div>
      </div>
      {formatObject[seriesNumber].formatValue === 'Currency' ? (
        <>
          <div
            className="optionDescription "
            style={{
              marginTop: '2px',
              marginBottom: '0px',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Currency Symbol
          </div>
          <div
            style={{
              padding: '0',
              marginTop: '0px',
              marginBottom: '8px',
              marginLeft: '5px',
              marginRight: '5px',
            }}
          >
            <TextField
              id="currency-symbol-input"
              variant="outlined"
              value={formatObject[seriesNumber]?.currencySymbol ?? '$'}
              onChange={(event) => {
                dispatch(
                  updateFormatOption(
                    propKey,
                    'xAxisFormats',
                    'currencySymbol',
                    event.target.value,
                    seriesNumber,
                  ),
                );
              }}
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  height: '26px',
                  backgroundColor: 'white',
                  fontSize: '13px',
                  '& fieldset': {
                    border: '1px solid rgb(211, 211, 211)',
                  },
                  '&:hover fieldset': {
                    border: '1px solid #2bb9bb',
                  },
                  '&.Mui-focused fieldset': {
                    border: '1px solid #2bb9bb',
                  },
                },
                '& .MuiOutlinedInput-input': {
                  padding: '0 8px',
                },
              }}
            />
          </div>
        </>
      ) : null}
      {formatObject[seriesNumber].formatValue === 'Percent' ? (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              marginTop: '-10px',
              marginBottom: '10px',
            }}
          >
            <div
              className="optionDescription"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              <span> Percent Type </span>
              <Tooltip
                placement="top"
                arrow
                title={
                  <div>
                    <p style={{ margin: 0, padding: 0 }}>
                      Calculated: Multiplies by 100 and appends the % symbol.
                    </p>
                    <p style={{ margin: 0, padding: 0 }}>Non Calculated: Appends the % symbol.</p>
                  </div>
                }
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: '11px',
                    },
                  },
                }}
              >
                <InfoOutlineIcon fontSize="small" />
              </Tooltip>
            </div>
            <div className="radioButtons" style={{ padding: '0' }}>
              <div
                className={
                  formatObject[seriesNumber].percentageCalculate === true
                    ? 'radioButtonSelected'
                    : 'radioButton'
                }
                style={{
                  backgroundColor:
                    formatObject[seriesNumber].percentageCalculate === true
                      ? 'rgba(224, 224, 224, 1)'
                      : 'white',
                  cursor:
                    formatObject[seriesNumber].percentageCalculate === true ? 'auto' : 'pointer',
                  fontWeight:
                    formatObject[seriesNumber].percentageCalculate === true ? '600' : 'normal',
                }}
                onClick={() => {
                  dispatch(
                    updateFormatOption(
                      propKey,
                      'xAxisFormats',
                      'percentageCalculate',
                      true,
                      seriesNumber,
                    ),
                  );
                }}
              >
                Calculated
              </div>
              <div
                className={
                  formatObject[seriesNumber].percentageCalculate === false
                    ? 'radioButtonSelected'
                    : 'radioButton'
                }
                style={{
                  backgroundColor:
                    formatObject[seriesNumber].percentageCalculate === false
                      ? 'rgba(224, 224, 224, 1)'
                      : 'white',
                  cursor:
                    formatObject[seriesNumber].percentageCalculate === false ? 'auto' : 'pointer',
                  fontWeight:
                    formatObject[seriesNumber].percentageCalculate === false ? '600' : 'normal',
                }}
                onClick={() => {
                  dispatch(
                    updateFormatOption(
                      propKey,
                      'xAxisFormats',
                      'percentageCalculate',
                      false,
                      seriesNumber,
                    ),
                  );
                }}
              >
                Non Calculated
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      {/*  */}
      {formatObject[seriesNumber].formatValue !== 'Percent' && (
        <>
          <div
            className="optionDescription"
            style={{
              marginTop: '0px',
              marginBottom: '0px',
              paddingLeft: '3px',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            <label
              htmlFor="enableDisable"
              className="enableDisableLabel"
              style={{ color: iconColor ? iconColor : '#404040' }}
            >
              Separator
            </label>
          </div>
          <div
            className="radioButtons"
            style={{ padding: '0', margin: '0 4px 0.5rem 6px', paddingLeft: '0px' }}
          >
            {renderSeparatorOptions()}
          </div>
        </>
      )}
      <div
        className="optionDescription"
        style={{
          marginTop: '0px',
          marginBottom: '0px',
          paddingLeft: '3px',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        <label
          htmlFor="enableDisable"
          className="enableDisableLabel"
          style={{ color: iconColor ? iconColor : '#404040' }}
        >
          Round Off
        </label>
      </div>
      <div
        className="optionDescription"
        style={{
          paddingTop: '0px',
          paddingBottom: '0px',
          marginTop: '-7px',
          paddingLeft: '6px',
          paddingRight: '4px',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '5px',
          backgroundColor: backgroundColor ? backgroundColor : 'transparent',
        }}
      >
        <Checkbox
          id="enableDisable"
          checked={formatObject[seriesNumber].enableRounding}
          style={{
            transform: 'scale(0.8)',
            paddingRight: '0px',
            paddingLeft: '0px',
          }}
          sx={{
            color: iconColor || '#a6a6a6',
            '&.Mui-checked': {
              color: iconColor || '#a6a6a6',
            },
            '&:hover': {
              backgroundColor: backgroundColor ? backgroundColor : 'transparent !important',
            },
          }}
          onChange={() => {
            dispatch(
              updateFormatOption(
                propKey,
                'xAxisFormats',
                'enableRounding',
                !formatObject[seriesNumber].enableRounding,
                seriesNumber,
              ),
            );
          }}
        />
        <InputPositiveNumber
          value={formatObject[seriesNumber].roundingDigits}
          updateValue={(value: number) => {
            if (value >= 0 && value <= 4) {
              dispatch(
                updateFormatOption(propKey, 'xAxisFormats', 'roundingDigits', value, seriesNumber),
              );
            } else if (value > 4) {
              dispatch(
                updateFormatOption(propKey, 'xAxisFormats', 'roundingDigits', 4, seriesNumber),
              );
            } else {
              dispatch(
                updateFormatOption(propKey, 'xAxisFormats', 'roundingDigits', 0, seriesNumber),
              );
            }
          }}
          disabled={formatObject[seriesNumber].enableRounding ? false : true}
          iconColor={iconColor}
          backgroundColor={backgroundColor}
          fromFormats={true}
        />
        <span style={{ margin: '0 auto', fontWeight: 'normal', color: iconColor }}>decimal</span>
      </div>
    </React.Fragment>
  );
};

export default XAxisFormat;
